import React from 'react';
import Link from './TrackedLink';

const Breadcrumb = ({ children }) => {
	let position = 1;

	// Adds the position to each child element (aka each BreadcrumbItem)
	const childrenWithPosition = React.Children.map(children, child =>
		React.cloneElement(child, { position: ++position })
	);
	return (
		<nav className="nav-breadcrumb">
			<ol className="breadcrumb" itemScope itemType="http://schema.org/BreadcrumbList">
				<li
					className="breadcrumb-item"
					itemProp="itemListElement"
					itemScope
					itemType="http://schema.org/ListItem"
				>
					<Link to="/" itemProp="item">
						<span itemProp="name">Home</span>
					</Link>
					<meta itemProp="position" content="1" />
				</li>
				{ childrenWithPosition }
			</ol>
		</nav>
	);
};

export default Breadcrumb;


// WEBPACK FOOTER //
// ./src/pages/common/Breadcrumb.js